import React, { Component } from 'react';
import { Container, Row } from 'reactstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import { inject, observer } from 'mobx-react';
import { CollapseItemTableIndicator } from '../../../comum/components/CollapseItemTableIndicator';
import DetalheSolicitacao from './DetalheSolicitacao';
import Checkbox from '../../../comum/components/Checkbox'
import Tooltip from "../../../comum/components/Tooltip";
import LoadingImage from '../../../comum/components/LoadingImage';

@inject("store")
@observer
export class TabelaRegistros extends Component{
    constructor(props){
        super(props);
        this.controller = props.controller
        
    };


    render(){
        const detalhesSolicitacao = {
            renderer: (row, rowIndex) => <DetalheSolicitacao row={row} rowIndex={rowIndex} />,
            showExpandColumn: true,
            expandByColumnOnly: true,
            expandHeaderColumnRenderer: () => "Detalhes",
            onExpandAll: (isExpandAll, results, e) => {
                e.PreventDefault();
            },
            expandColumnPosition: 'right',
            expandColumnRenderer: ({ expanded }) => {
                return (
                    <CollapseItemTableIndicator expanded={expanded} />
                );
            }
        };

        const selectRow = {
            mode: 'checkbox',
            selectionHeaderRenderer: ({ indeterminate, ...rest }) => (
                <Tooltip tooltipText={`Clique aqui para ${rest.checked || indeterminate ? "desmarcar" : "selecionar"} todos os registros`}>
                    <Checkbox ativo={rest.checked} onClick={() => { }} />
                </Tooltip>
            ),
            selectionRenderer: ({ mode, ...rest }) =>
                <Checkbox ativo={rest.checked} onClick={() => { }} />,
            onSelect: (row, isSelect, rowIndex, e) => {
                e.preventDefault()
                e.stopPropagation()
                console.log(row)
                this.controller.marcar(row)
            },
            onSelectAll: (isSelect, rows, e) => {
                e.preventDefault()
                e.stopPropagation()
                while (this.controller.hasMore) {
                    this.controller.loadNextTurn()
                }

                this.controller.marcarTodas(isSelect)
                if (isSelect) {
                    const selecao = this.controller.dadosTabela.map((item, index) => {
                        return item.SolicitacaoId
                    })
                    return selecao
                } else {
                    return []
                }
            },
        }

        return (
                <Container fluid className="tabela-container">
                    <BootstrapTable bootstrap4
                        columns={this.controller.colunasTabela}
                        data={this.controller.dadosTabela.slice()}
                        sort={ { dataField: 'DataEntrada', order: 'desc' } }
                        keyField="SolicitacaoId"
                        striped
                        bordered={false}
                        noDataIndication={() => "Nenhum registro encontrado"}
                        classes="tabela"
                        expandRow={detalhesSolicitacao}
                        selectRow={selectRow}                  
                    />                  
            </Container>
        )
    }

};


// WEBPACK FOOTER //
// ./src/modules/agendamento/entrada-antecipada/components/TabelaRegistros.js